import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map } from "rxjs/operators";
import GlobalStore from "@/store/modules/global";
import { Processo } from "@/models/processo-eletronico/processo";

const processo = require("@/query/processo-eletronico/Processo.graphql");
export class ProcessoAPI extends BaseAPI<Processo> {
  constructor() {
    super();    
  }

  public findByViproc(
    identificadorViproc: string,
    recaptcha: string
  ): AxiosObservable<Processo> {
    return this.axios
    .post(`${this.graphqlUrl}`, {
      query: print(processo),
      variables: { 
        input: { 
          identificadorViproc, recaptcha 
        } 
      }
    })
      .pipe(
        map((data: any) => {
          const { process } = data;
          if (!process && data.errors && data.errors.length) {
            GlobalStore.setSnackBar({
              message: data.errors[0].exception.message,
              show: true,
              type: "error"
            });
            throw data.errors[0].exception.message;
          }
          return process;
        })
      );
  }  
}
